import React from "react";
import Loader from "react-js-loader";
import { CommonColor } from "../../Utils/color";
import { ROUND_LOADER_TYPE } from "../../Utils/constant";
import SearchLoader from "./SearchLoader";

export default function AppLoader(props) {
  return props.pageNumber !== 1 ? (
    <SearchLoader />
  ) : (
    <Loader
      type={ROUND_LOADER_TYPE}
      bgColor={CommonColor.primary_color}
      size={40}
      color={CommonColor.white}
      timeout={3000}
    />
  );
}
